<template>
  <div>
    <b-card class="col-lg-8 col-md-12" no-body>
      <div class="m-2">

        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="6">
            <b-form-group label="Nhập 10 số MSIN">
              <validation-provider #default="{ errors }">
                <b-form-input v-model="msin" :state="errors.length > 0 ? false:null"
                              placeholder="Nhập số từ số 9 - 19 trên seri sim" @keypress.enter="loadData"/>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Số thuê bao">
              <h2 class="text-primary" v-html="msisdn"></h2>
            </b-form-group>
          </b-col>
          <!-- Per Page -->
        </b-row>
      </div>
    </b-card>


  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';


export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {


  },
  watch: {},
  methods: {
    async loadData() {
      this.$store.dispatch('crm/fetchMsisdnFromMsin', this);
    },
  },
  data() {
    return {
      msisdn: '',
      msin: '',
      isLoading: false,
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
